import {Component, OnInit} from '@angular/core';
import {Product} from "../../../../common/interfaces/Product";
import {MerchantService} from "../../../../common/services/merchant.service";
import {Merchant} from "../../../../common/interfaces/Merchant";
import {MerchantApi} from "../../../../common/apis/merchant-api";


@Component({
  selector: 'merchant-menu-tab',
  templateUrl: './merchant-menu-tab.component.html',
  styleUrls: ['./merchant-menu-tab.component.scss']
})
export class MerchantMenuTabComponent implements OnInit {

  products: Product[] = []
  merchant: Merchant | null
  selectedCategory: string = 'all'
  showLoadMoreButton: boolean = true
  loading: boolean = false
  pageNumber: number = 1
  loadMoreProductsLabel = $localize`:@@loadMoreProducts:Load more products`

  constructor(
    private merchantApi: MerchantApi,
    private merchantService: MerchantService
  ) {
  }

  ngOnInit(): void {
    this.merchantService.getProducts().subscribe({
      next: (products) => {
        this.products = products
        this.showLoadMoreButton = products.length >= 15;
      }
    })
    this.merchantService.getMerchantInfo().subscribe({
      next: (merchant) => this.merchant = merchant
    })
  }

  filterByCategory(category: string) {
    this.selectedCategory = category
    this.merchantService.getProducts().subscribe({
      next: (products) => {
        if (category !== "all") {
          this.products = products.filter((value, _, __) => value.categoryId === category)
        } else {
          this.products = products
        }
      }
    })
  }

  loadMore() {
    ++this.pageNumber
    this.loading = true
    this.merchantApi.getProductsByMerchantId(this.merchant!.id, this.pageNumber).subscribe({
      next: (products) => {
        this.loading = false
        this.products.push(...products.data)
        if (products.data.length < 15) {
          this.showLoadMoreButton = false
        }
      },
      error: (_) => {
        this.loading = false
      }
    })
  }

}
